const mainFooterMessages = {
  COPYRIGHT: `© ${new Date().getFullYear()} sonet.io, inc`,
  SONET_NAME: 'sonet.io',
};

export default mainFooterMessages;
